import { Link } from 'react-router-dom';

interface BreadcrumbProps {
    history: { title: string; to: string }[];
    current: string;
}

const Breadcrumb = ({ history, current }: BreadcrumbProps) => {
    return (
        <div className='breadcrumb-page' data-aos='fade'>
            <div className='container'>
                <nav aria-label='breadcrumb'>
                    <ol className='breadcrumb'>
                        {history.map(item => (
                            <li className='breadcrumb-item'>
                                <Link to={item.to}>{item.title}</Link>
                            </li>
                        ))}
                        <li className='breadcrumb-item active' aria-current='page'>
                            {current}
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    );
};
export default Breadcrumb;
